import {Order} from '../../types/order';
import {getTotal} from '../order/getTotal';

export function getOrderTotalOrEstimate(order: Order, options = { excludeTax: false}): number {
    return Number(order.orderValueType === "ESTIMATE"
    ? order.orderValueEstimate
    : getTotal(order, options));
}